var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconAddBtn = function SvgIconAddBtn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/icon_add_btn"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25 10.5002V13.7502C9.25 14.1644 9.58579 14.5002 10 14.5002C10.4142 14.5002 10.75 14.1644 10.75 13.7502V10.5002L13.75 10.5002C14.1642 10.5002 14.5 10.1644 14.5 9.75023C14.5 9.33602 14.1642 9.00023 13.75 9.00023L10.75 9.00023V6.00023C10.75 5.58602 10.4142 5.25023 10 5.25023C9.58579 5.25023 9.25 5.58602 9.25 6.00023V9.00023L6 9.00023C5.58579 9.00023 5.25 9.33602 5.25 9.75023C5.25 10.1644 5.58579 10.5002 6 10.5002L9.25 10.5002Z",
    fill: "#753BBD"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconAddBtn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_add_btn.3d4d614e.svg";
export { ForwardRef as ReactComponent };